var _defs, _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCargoTruck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    "data-name": "Capa 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 916.4 574.6",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        fill: #3b66b0;\r\n        stroke-width: 0px;\r\n      }\r\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M767,407.8c-37.5,0-68,30.5-68,68s30.5,68,68,68,68-30.5,68-68-30.5-68-68-68ZM767,495.8c-11,0-20-9-20-20s9-20,20-20,20,9,20,20-9,20-20,20Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M760.5,42.1h-117.5c-8.8,0-16,7.2-16,16v395c0,8.8,7.2,16,16,16h17c7.9,0,14.9-5.7,16-13.6,6.3-48.1,44.7-78,91.1-78s84.8,29.8,91.1,78c1,7.9,8,13.6,16,13.6h17c8.8,0,16-7.2,16-16v-239c0-3.8-1.3-7.4-3.7-10.3l-130.5-156c-3.3-3.6-7.8-5.7-12.5-5.7h0ZM675,179.1v-80c0-8.8,7.2-16,16-16h43.5c4.7,0,9.2,2.1,12.3,5.8l66.7,80c8.7,10.4,1.3,26.2-12.3,26.2h-110.2c-8.8,0-16-7.2-16-16Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M22,469.1h41c7.9,0,14.9-5.7,16-13.6,6.3-48.1,44.7-78,91.1-78s84.8,29.8,91.1,78c1,7.9,8,13.6,16,13.6h302c8.8,0,16-7.2,16-16v-80c0-8.8-7.2-16-16-16H22c-8.8,0-16,7.2-16,16v80c0,8.8,7.2,16,16,16Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M170,407.8c-37.5,0-68,30.5-68,68s30.5,68,68,68,68-30.5,68-68-30.5-68-68-68ZM170,495.8c-11,0-20-9-20-20s9-20,20-20,20,9,20,20-9,20-20,20Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCargoTruck);
export default __webpack_public_path__ + "static/media/cargo-truck.2ffb1ba65a63d0469e39f9f4bdb9c293.svg";
export { ForwardRef as ReactComponent };